import { OrderDirection } from "_shared/_api/ordering/order-direction";

/** The order fields `GET permissions/templates` takes (`PermissionTemplateOrderField` in the Permissions API). */
export enum PermissionTemplateOrderField {
  CreatedDate = "CreatedDate",
  DeletedDate = "DeletedDate",
  Name = "Name",
}

export type PermissionTemplateOrderParametersProps = {
  orderBy?: PermissionTemplateOrderField;
  orderDir?: OrderDirection;
};

/**
 * The order `GET permissions/templates` takes. With no `orderBy` the API orders newest first.
 */
export default class PermissionTemplateOrderParameters {
  public readonly orderBy?: PermissionTemplateOrderField;
  public readonly orderDir?: OrderDirection;

  public get searchParams(): URLSearchParams {
    const searchParams = new URLSearchParams();
    if (this.orderBy) searchParams.append("orderBy", this.orderBy);
    if (this.orderDir) searchParams.append("orderDir", this.orderDir);
    return searchParams;
  }

  public constructor(props: PermissionTemplateOrderParametersProps) {
    this.orderBy = props.orderBy;
    this.orderDir = props.orderDir;
  }

  public isEqualTo(other: PermissionTemplateOrderParameters | undefined): boolean {
    if (!other) return false;
    return this.orderBy === other.orderBy && this.orderDir === other.orderDir;
  }

  public toString(): string {
    return this.searchParams.toString();
  }
}
